import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CdnIcon, QntBadge } from '@shared/ui';

import { ListItemButton, ListItemText } from '@mui/material';

import { Route } from '../../../../Account/types';

import { useTheme } from '../../../../theme';
import { useIsTablet } from '../../../../utils';

interface Props {
	route: Route;
	isSelected: boolean;
}

const Item: React.FunctionComponent<Props> = ({ route, isSelected }) => {
	const { SidebarItem: css } = useTheme('SidebarItem');

	const { t } = useTranslation('Account');

	const isTablet = useIsTablet();

	return (
		<ListItemButton
			selected={isSelected}
			classes={{
				root: css.sidebarItem,
				selected: css.sidebarItem_selected
			}}
		>
			<CdnIcon className={css.sidebarItem__icon} icon={route.icon} />
			<ListItemText classes={{ primary: css.sidebarItem__text }} primary={t(route.title)} />
			{route.badgeContent > 0 && (
				<QntBadge count={route.badgeContent} variant={isTablet ? 'default' : 'invert'} />
			)}
		</ListItemButton>
	);
};

export default Item;
